import React from 'react'
import { useNavigate } from 'react-router-dom'

const FinnencierSection2 = () => {
  const navigate = useNavigate()
  return (
    <section className="financier-section financier-section-2"> 
  <div className="container">
    <div className="row">
      <div className="col-lg-6">
        <div className="financier-content">
          <h1>L'immobilier, <br />
            c’est <span> bien plus </span> <br />
            qu’un simple <br />
            <span> investissement</span> <br />
            financier.</h1>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="financier-content">
          <p>Beatimo est un développeur immobilier unique en son genre qui cherche constamment à mieux équilibrer les intérêts de chaque partenaire et intervenant concerné par les projets immobiliers. Notre approche unique et holistique, combinant une expertise financière hors pair à l'expérience sur le terrain de projets immobiliers au travers des années, nous permet de bien comprendre les besoins de chaque partie prenante et maximiser la valeur livrée à tous nos partenaires.</p>
          <p>Choisir Beatimo comme partenaire à long terme, c’est de faire équipe avec des gens passionnés qui sont prêts à tout pour surmonter les obstacles et les défis qui se présent à nous lorsqu’on désire changer le monde pour le mieux. C’est choisir de créer et bâtir ensemble des environnements de vie où la Béatitude prend place dans le cœur des gens, une bouchée de bonheur à la fois.</p>
          <p>On cherche tous à accomplir de grandes choses. Maximisez votre impact.</p>
          {/* <p>Beatimo excelle en actuariat, cumulant des années d'expérience. Nos conseils sur mesure, résultat d'une expertise approfondie, optimisent la gestion des risques, la tarification des assurances et la planification financière.</p>
          <p>Bénéficiez d'une approche proactive assurant stabilité et rendements optimaux. Choisissez Beatimo pour une expertise actuarielle d'élite.</p> */}
          <div className="financier-button">
            <button className="services-btn" onClick={()=>navigate('/capital-propos')}>en savoir plus</button>
            <button className="icon-btn"><img src="assets/image/arrow-right.png" alt="finnecncier-section" /></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  )
}

export default FinnencierSection2
